import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import GeneralCsvReportContMain from "presentation/view/container/GeneralCsvReport/GeneralCsvReportContMain";

CommonEntrypoint(<GeneralCsvReportContMain />)